module.exports = __webpack_public_path__ + "img/sharpshooters-oath.ecbd2af1.webp";